var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCalendarioVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.211 2.53h-2.605V1.172a.906.906 0 0 0-1.813 0v1.36H9.106V1.17a.906.906 0 0 0-1.813 0v1.36H4.688A3.742 3.742 0 0 0 .95 6.269v19.258a3.742 3.742 0 0 0 3.738 3.738h21.523a3.742 3.742 0 0 0 3.739-3.738V6.269a3.742 3.742 0 0 0-3.739-3.738zM4.688 4.344h2.605v.907a.906.906 0 0 0 1.813 0v-.907h12.687v.907a.906.906 0 0 0 1.813 0v-.907h2.605c1.062 0 1.926.864 1.926 1.926v2.152H2.762V6.27c0-1.062.864-1.926 1.926-1.926zm21.523 23.11H4.688a1.928 1.928 0 0 1-1.926-1.926V10.234h25.375v15.293a1.928 1.928 0 0 1-1.926 1.926z",
    fill: "#a9ba37",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCalendarioVerde);
export default __webpack_public_path__ + "static/media/icono-calendario-verde.234ca751034396cf52c377faf4d24a16.svg";
export { ForwardRef as ReactComponent };